<template>
  <div class="labo flex">
    <img
      :src="data.checkmallBusinessLogo"
      v-if="data.checkmallBusinessLogo"
      class="labo-logo pointer"
      @click="toLab"
    />
    <div class="labo-info">
      <div class="labo-name">{{ data.checkmallBusinessName }}</div>
      <div class="labo-line">
        <label>电话：</label>
        <span>{{ data.checkmallBusinessContactsPhone }}</span>
      </div>
      <div class="labo-line">
        <label>联系人：</label>
        <span>{{ data.checkmallBusinessContactsName }}</span>
      </div>
      <div class="labo-line ellipsis">
        <label>地址：</label>
        <span>{{ data.laboratoryLocationProvince }}</span>
        <span>{{ data.laboratoryLocationCity }}</span>
        <span>{{ data.laboratoryLocationCounty }}</span>
        <span>{{ data.laboratoryAddress }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "laboratory",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      ellipsis: true,
    };
  },
  // computed: {
  //   checkInfo() {
  //     const { laboratoryCheckInfo } = this.data;
  //     const len = laboratoryCheckInfo.length;
  //     const max = 7;
  //     if (len > max && this.ellipsis) {
  //       return `${laboratoryCheckInfo.substring(0, max)}...`;
  //     }
  //     return laboratoryCheckInfo;
  //   },
  // },
  methods: {
    toLab() {
      this.$jump.push({
        name: "labDetail",
        query: { id: this.data.laboratoryId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.labo {
  padding: 10px;
  margin-bottom: 15px;
  background: white;
  &-name {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
  }
  &-logo {
    width: 80px;
    height: 80px;
    object-fit: contain;
    background: #e7e7e7;
  }
  &-info {
    padding-left: 10px;
    width: calc(100% - 80px);
  }
  &-line {
    margin-bottom: 5px;
    label {
      color: #999999;
    }
  }
}
</style>
